import PageShell, { hasConfirmSlot } from "../components/PageShell";
import company from "../data/company.json";
import copy from "../lib/catalog/copy-strings.json";

export default function AboutPage() {
        const c = copy.about;
        const hasConfirm = hasConfirmSlot(...c.cards.map(x => x.body));
        const legalSuffix = c.legal_strip_suffix.replace("{year}", company.founded_year);
        return (
                <PageShell title={c.title} path="/about" hasConfirm={hasConfirm}>
                        <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#F59E0B]" data-testid="about-eyebrow">{c.eyebrow}</p>
                        <h1 className="mt-3 font-display uppercase leading-[0.95] text-[44px] md:text-[56px] lg:text-[76px]" data-testid="about-heading">
                                <span className="text-white">{c.heading_lead}</span>
                                <span className="text-[#F59E0B]">{c.heading_accent}</span>
                        </h1>
                        <p className="mt-6 text-white/70 leading-relaxed max-w-[56ch]" data-testid="about-subhead">{c.subhead}</p>

                        <section className="mt-14 space-y-5 text-white/80 leading-relaxed max-w-[68ch]" data-testid="about-origin">
                                {c.origin.map((p, i) => <p key={i}>{p}</p>)}
                        </section>

                        <section className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6" data-testid="about-stats">
                                {c.stats.map((s) => (
                                        <div key={s.value} className="border border-white/10 p-5">
                                                <p className="font-display text-3xl md:text-4xl text-[#F59E0B]">{s.value}</p>
                                                <p className="mt-2 text-xs md:text-sm text-white/60">{s.label}</p>
                                        </div>
                                ))}
                        </section>

                        <section className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
                                {c.cards.map((card) => (
                                        <div key={card.title} className="border border-white/10 p-6">
                                                <h3 className="font-mono text-[12px] tracking-[0.16em] uppercase text-[#F59E0B]">{card.title}</h3>
                                                <p className="mt-3 text-white/70 leading-relaxed text-sm">{card.body}</p>
                                        </div>
                                ))}
                        </section>

                        <section className="mt-14 border border-white/10 p-6">
                                <p className="text-white/80 leading-relaxed">
                                        {c.cta_prefix}
                                        <a href={`https://wa.me/${company.whatsapp_phone_e164}`} className="text-[#F59E0B]">{company.business_phone}</a>
                                        {c.cta_middle}
                                        <a href={`mailto:${company.support_email}`} className="text-[#F59E0B]">{company.support_email}</a>
                                        {c.cta_suffix}
                                </p>
                                <a
                                        href={company.calendly_consult_url}
                                        target="_blank" rel="noopener noreferrer"
                                        data-testid="about-consult-cta"
                                        className="mt-5 inline-block border border-[#F59E0B] text-[#F59E0B] hover:bg-[#F59E0B] hover:text-black font-mono text-[12px] tracking-[0.18em] uppercase px-5 py-3 min-h-[48px]"
                                >
                                        {c.cta_label}
                                </a>
                        </section>

                        <section className="mt-14 border-t border-white/10 pt-6 text-white/50 text-xs" data-testid="about-legal-strip">
                                <p>{c.legal_strip_prefix}{company.address_city}, {company.address_country}{legalSuffix}</p>
                        </section>
                </PageShell>
        );
}
